<button mat-icon-button [matTooltip]="'MAIN.APP.TOOLBAR.HELP' | translate" (click)="open()" class="intercom-button">
  <mat-icon>live_help</mat-icon>
</button>

